"use client";
import { jsx } from "react/jsx-runtime";
import { useCallback } from "react";
import { useTheme } from "@mui/material/styles";
import { Carousel } from "@nxt-costco-com/forge-components";
import { SpaceLg } from "@nxt-costco-com/forge-design-tokens";
import { CostcoBox } from "../../Util/CostcoBox.js";
import { useContainerSize } from "../../../hooks/useContainerSize/index.js";
import { getCarouselSettings } from "./lib.js";
import { MultiRowContainer, MultiRowItem } from "./styles.js";
const CategorySet = ({
  ads,
  enableAutoplay = false,
  enableTwoRowDisplay = false,
  randomizeItems,
  titleId,
  bodyBackgroundColor
}) => {
  const theme = useTheme();
  const [containerRef, { width }] = useContainerSize();
  const carouselSettings = getCarouselSettings({
    enableTwoRowDisplay,
    theme,
    width
  });
  const {
    columns,
    itemsPerSlide,
    itemsTwoRowMax,
    navigationButtonTopOffset
  } = carouselSettings;
  const categoryTileCount = ads == null ? void 0 : ads.length;
  const isTwoRowDisplay = enableTwoRowDisplay && categoryTileCount > itemsPerSlide;
  const renderItems = useCallback(() => {
    if (isTwoRowDisplay) {
      const twoRowCategoryTiles = Array.from(
        { length: Math.ceil(categoryTileCount / itemsTwoRowMax) },
        (_, index) => {
          const start = index * itemsTwoRowMax;
          const group = ads.slice(start, start + itemsTwoRowMax);
          return /* @__PURE__ */ jsx(
            MultiRowContainer,
            {
              columns,
              children: group.map((tile, tileIndex) => /* @__PURE__ */ jsx(
                MultiRowItem,
                {
                  columns,
                  children: tile
                },
                `tile-${start + tileIndex}`
              ))
            },
            `group-${start}`
          );
        }
      );
      return twoRowCategoryTiles;
    }
    return ads;
  }, [ads, categoryTileCount, columns, isTwoRowDisplay, itemsTwoRowMax]);
  if (!ads) {
    return null;
  }
  return /* @__PURE__ */ jsx(
    CostcoBox,
    {
      ref: containerRef,
      sx: {
        backgroundColor: bodyBackgroundColor || "transparent",
        borderRadius: "10px"
      },
      children: /* @__PURE__ */ jsx(
        Carousel,
        {
          disableBottomControls: isTwoRowDisplay ? categoryTileCount / 2 <= itemsPerSlide : categoryTileCount <= itemsPerSlide,
          disableControls: isTwoRowDisplay ? categoryTileCount / 2 <= itemsPerSlide : categoryTileCount <= itemsPerSlide,
          isAutoplay: enableAutoplay,
          items: renderItems(),
          itemsPerSlide,
          labelledBy: titleId,
          navigationButtonTopOffset,
          navigationButtonsMobileDisplay: true,
          randomizeItems,
          slideGap: SpaceLg,
          wrapAround: true
        }
      )
    }
  );
};
export {
  CategorySet
};
